import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98cf0630"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payout-wrapper" }
const _hoisted_2 = { class: "payout-list" }
const _hoisted_3 = { class: "approve-comment" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Comment:")
const _hoisted_6 = { class: "title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tips", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" No ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_ExclamationCircleFilled = _resolveComponent("ExclamationCircleFilled")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.tableModalVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tableModalVisible) = $event)),
    onCancel: _ctx.handleCancel
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ExclamationCircleFilled, { class: "title-icon" }),
        _hoisted_7
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        onClick: _ctx.handleConfirm,
        disabled: _ctx.commentsRequired && !_ctx.comments,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["onClick", "disabled", "loading"]),
      _createVNode(_component_a_button, { onClick: _ctx.handleCancel }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item[_ctx.formatkey]), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            (_ctx.commentsRequired)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
              : _createCommentVNode("", true),
            _hoisted_5
          ]),
          _createVNode(_component_a_textarea, {
            value: _ctx.comments,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comments) = $event)),
            placeholder: _ctx.placeholderMap[_ctx.approvalType],
            rows: 4
          }, null, 8, ["value", "placeholder"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}